import styled from 'styled-components';

export const Container = styled.div`
  position: sticky;
  width: 100vw;
  background-color: #FF8A00;
  padding: 0 1rem 0 1rem;
  display: flex;
  align-items: end;
  height: 100px;
`;
